import { render, staticRenderFns } from "./SubscribePlanSwitcher.vue?vue&type=template&id=8ded9548&scoped=true&"
import script from "./SubscribePlanSwitcher.vue?vue&type=script&lang=js&"
export * from "./SubscribePlanSwitcher.vue?vue&type=script&lang=js&"
import style0 from "./SubscribePlanSwitcher.vue?vue&type=style&index=0&id=8ded9548&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ded9548",
  null
  
)

export default component.exports